import CardTitle from "./CardTitle";

const Transparency = () => {
   return [
      <div>
         <CardTitle num={1} />
         <ul>
            <li>We openly share the reasons for our decisions</li>
            <li>We openly share the outcomes of our decisions</li>
         </ul>
      </div>,
      <div>
         <CardTitle num={2} />
         <ul>
            <li>Outcomes openly shared, always</li>
            <li>
               Avado Live and Avado Weekly are designed to share our truths
               openly and regularly
            </li>
         </ul>
      </div>,
      <div>
         <CardTitle num={3} />
         <ul>
            <li>
               We deal with problems openly and honestly (see some stuff we have
               about Radical Candour)
            </li>
         </ul>
      </div>,
      <div>
         <CardTitle num={4} />
         <ul>
            <li>Outcomes even over effort / input</li>
         </ul>
      </div>,

      <div>
         <CardTitle num={5} />
         <h3>We smile at: 😍</h3>
         <ul>
            <li>Openness and shows of vulnerability </li>
            <li>Open questions</li>
         </ul>
         <br />
         <h3>We frown at: 😒</h3>
         <ul>
            <li>Cynicism</li>
            <li>Closedness</li>
            <li>Hiding from the truth</li>
         </ul>
      </div>,
      <div>
         <CardTitle num={6} />
         <ul>
            <li>
               We give feedback that helps people learn, grow and see their
               blindspots
            </li>
            <li>We actively discuss our successes, learnings and failures</li>
         </ul>
      </div>,
      <div>
         <CardTitle num={7} />
         <ul>
            <li>Specific is essential</li>
            <li>Expert opinions are delivered unfiltered</li>
            <li>
               We share what we’re learning and improving personally, whether
               its behavioural or technical
            </li>
         </ul>
      </div>,
      <div>
         <CardTitle num={8} />
         <ul>
            <li>Agree and disagree openly, with an explanation</li>
         </ul>
      </div>,
   ];
};

export default Transparency;
